import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const New = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 28 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_1357_13204)">
        <path
          d="M6.31493 23.6024C9.06209 20.5098 7.89965 16.217 2.06284 15.5237C7.9056 14.4553 8.93259 9.20705 5.56527 6.4027C10.718 7.96199 12.906 7.24165 14.2784 1.63094C15.085 7.2896 17.6276 9.28883 21.5749 7.13829C18.1667 12.2067 21.9497 13.8972 25.9191 14.8826C20.283 15.9132 19.4984 18.7496 21.2223 22.8842C17.5678 20.8756 14.5987 22.5433 14.8186 27.1069C14.1234 23.2262 9.78991 21.5669 6.31493 23.6024Z"
          fill="white"
          stroke={color}
          strokeWidth="1.4"
          strokeLinejoin="round"
        />
        <path d="M14 10.6676V18.6355" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
        <path d="M10.0625 14.6514L18.0304 14.6514" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_1357_13204">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default New
